import Hero from '../sections/Hero';
import Clients from '../sections/Clients';
import Stats from '../sections/Stats';
import PainPoints from '../sections/PainPoints';
import ServicesPreview from '../sections/ServicesPreview';
import Industries from '../sections/Industries';
import Process from '../sections/Process';
import FeaturedResults from '../sections/FeaturedResults';
import WhyUs from '../sections/WhyUs';
import PortfolioPreview from '../sections/PortfolioPreview';
import Testimonials from '../sections/Testimonials';
import TestimonialForm from '../components/TestimonialForm';
import BlogPreview from '../sections/BlogPreview';
import FAQ from '../sections/FAQ';
import CTA from '../sections/CTA';

export default function HomePage() {
  return (
    <>
      <Hero />
      <Clients />
      <PainPoints />
      <ServicesPreview />
      <Industries />
      <Process />
      <FeaturedResults />
      <Stats />
      <WhyUs />
      <PortfolioPreview />
      <Testimonials />
      <section className="home-testimonial-form-section">
        <TestimonialForm />
      </section>
      <BlogPreview />
      <FAQ />
      <CTA />
    </>
  );
}
